import { ErrorResponse, useInterval } from 'vrlcm-gui-utils';
import {
  PrecheckState,
  RequestState,
  ManualPreCheckError
} from 'vrlcm-gui-types';
import { useCallback, useEffect, useState } from 'react';

import { PrecheckApi } from 'vrlcm-gui-api';
import { toPrecheckState } from './util';

const initialState: PrecheckState = {
  groups: []
};

enum RequestStatus {
  Unknown,
  Settled,
  Pending,
  Failed
}

/**
 * settled ~ state won't change
 */
function isSettled(requestState: RequestState) {
  return (
    requestState === RequestState.FAILED ||
    requestState === RequestState.COMPLETED
  );
}

export function usePrecheckState(
  requestId?: string,
  manualPrecheckError?: ManualPreCheckError
): [PrecheckState, boolean] {
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.Unknown);
  const [error, setError] = useState(false);
  const [state, setState] = useState<PrecheckState>(initialState);

  const getRequest = useCallback(() => {
    if (requestId) {
      PrecheckApi.getPrecheckReport(requestId)
        .then(precheckResponse => {
          const s = toPrecheckState(precheckResponse);
          setStatus(
            isSettled(precheckResponse.requestState)
              ? RequestStatus.Settled
              : RequestStatus.Pending
          );
          setState(s);
        })
        .catch((err: ErrorResponse) => {
          if (err.response.status === 404) {
            setStatus(RequestStatus.Pending);
            setState(initialState);
          } else {
            setStatus(RequestStatus.Settled);
            setError(true);
          }
        });
    }
    if (manualPrecheckError && manualPrecheckError.isError) {
      setStatus(RequestStatus.Failed);
      setError(true);
    }
  }, [requestId]);

  useInterval(getRequest, status === RequestStatus.Pending ? 15000 : null);

  useEffect(() => {
    getRequest();
  }, [getRequest]);

  return [state, error];
}
